import { Icon } from './Icon';

type IconProps = {
  color?: string;
  size?: string;
};

export const SyncIcon: React.FC<IconProps> = ({ color, size, ...rest }) => {
  return (
    <Icon color={color} size={size} {...rest}>
      <path d="M18.207 5.54297L16.7852 6.96484C15.5547 5.73438 13.8594 4.96875 12 4.96875C8.36328 4.96875 5.38281 7.83984 5.21875 11.4219C5.19141 11.6133 5.35547 11.75 5.54688 11.75H6.3125C6.47656 11.75 6.61328 11.6406 6.64062 11.4492C6.80469 8.63281 9.12891 6.39062 12 6.39062C13.4766 6.39062 14.8164 6.99219 15.7734 7.97656L14.2969 9.45312C14.0781 9.67188 14.2422 10 14.5156 10H18.4531C18.6172 10 18.7812 9.86328 18.7812 9.67188V5.76172C18.7812 5.48828 18.4258 5.32422 18.207 5.54297ZM18.4258 11.75H17.6602C17.4961 11.75 17.3594 11.8867 17.332 12.0781C17.168 14.8945 14.8438 17.1094 12 17.1094C10.4961 17.1094 9.15625 16.5352 8.19922 15.5508L9.67578 14.0742C9.89453 13.8555 9.73047 13.5 9.45703 13.5H5.54688C5.35547 13.5 5.21875 13.6641 5.21875 13.8281V17.7656C5.21875 18.0391 5.54688 18.2031 5.76562 17.9844L7.1875 16.5625C8.41797 17.793 10.1133 18.5312 12 18.5312C15.6094 18.5312 18.5898 15.6875 18.7539 12.1055C18.7812 11.9141 18.6172 11.75 18.4258 11.75Z" />
    </Icon>
  );
};
